<template>

<div style="margin: 5px;">
    <InputGroup>
    <InputGroupAddon>Material Group</InputGroupAddon>
    <Dropdown v-model="value" :options="options" :disabled="disabled"/>
</InputGroup>
</div>


    
</template>  
<script>
import CommonService from "../../service/CommonService";
export default {
    props: ['modelValue', 'disabled'],
    emits:["update:modelValue"],
    components: {

    },
    data() {
        return {
            value: "",
             options: []
        }
    },
    CommonService:null,
    async created() {
        // let self=this;
         this.CommonService = new CommonService();
        this.value=this.modelValue;

         this.CommonService.GetMaterialGroup().then((data) => {
            self.options = data
        }) 
    },
    watch: {
        modelValue: function () {
              // watch it
             // console.log("Prop changed: ", newVal, " | was: ", oldVal);
              this.value = this.modelValue
            },
            value: function (newVal) {
              // watch it
             // console.log("Prop changed: ", newVal, " | was: ", oldVal);
              this.$emit("update:modelValue", newVal );
            },
          },
}
</script>
  
  